import SelectField from "components/controls/SelectField";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { ETaxonomy, IRowItem } from "library/types";
import { useMemo } from "react";

type Props = {
  item: IRowItem;
  readOnly?: boolean;
};

export function InsurerConsentTypeCell({ item, readOnly }: Props) {
  const consentOptions = useTaxonomyOptions(ETaxonomy.ConsentType);

  const defaultValue = useMemo(() => {
    return consentOptions.filter((option) => {
      return item?.insurerConsentType === option.value;
    });
  }, [consentOptions, item.insurerConsentType]);

  if (readOnly) {
    return defaultValue?.map((option) => option.text).join(", ");
  }
  return (
    <SelectField
      onClick={(e) => {
        e.stopPropagation();
      }}
      error={""}
      setFieldValue={(name, types) => {
        const id = types.value;

        item.updateState({
          ...item,
          isEdited: true,

          insurerConsentType: Number(id),
        });
      }}
      value={defaultValue[0] as any}
      label=""
      // options={implementationConsentOptions}
      options={consentOptions}
      name={"consentTypes"}
      noErrorSection
      noLabel
    />
  );
}
